import { IProject } from '_interfaces/project';
import Fuse from 'fuse.js';
import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { createCrudAtoms } from './utils/crudFactory';

export const projectsAtom = atom<IProject[]>([]);

export const selectedProjectAtom = atomWithStorage<IProject>('selectedProject', null);

// Derived atom that automatically syncs with Redux project data
// This atom will be populated when useSyncSelectedProject hook is used
export const syncedSelectedProjectAtom = atom(
  (get) => {
    const storedProject = get(selectedProjectAtom);
    return storedProject;
  },
  (get, set, newProject: IProject | null) => {
    set(selectedProjectAtom, newProject);
  }
);

export const selectedProjectIdAtom = atom<number | null>((get) => {
  const selectedProject = get(selectedProjectAtom);
  return selectedProject?.id || null;
});

export const projectSearchQueryAtom = atom('');

export const filteredProjectsAtom = atom((get) => {
  const projects = get(projectsAtom);
  const searchQuery = get(projectSearchQueryAtom).trim();

  if (!searchQuery) return projects;

  const fuse = new Fuse(projects, {
    keys: ['name', 'address', 'status'],
    threshold: 0.3,
    includeMatches: true,
  });

  const results = fuse.search(searchQuery);

  return results;
});

export const {
  addAtom: addProjectAtom,
  updateAtom: updateProjectAtom,
  deleteAtom: deleteProjectAtom,
} = createCrudAtoms<IProject>('projects');
